import { Button } from "flowbite-react";
import React from "react";
import { ModalContainer } from "./ModalContainer";
import { disclaimerKey } from "./DisclaimerModal";

const ANNOUNCEMENT_KEY = "dismissedMigrationAnnouncement_v2";

export default function AnnouncementModal() {
  const wasDismissed = localStorage.getItem(ANNOUNCEMENT_KEY) === "true";
  const disclaimerAccepted = localStorage.getItem(disclaimerKey) === "didAccept";

  const [show, setShow] = React.useState(!wasDismissed && disclaimerAccepted);

  // Listen for disclaimer acceptance so we can show after it's dismissed
  React.useEffect(() => {
    if (wasDismissed) return;

    const handleStorage = () => {
      if (localStorage.getItem(disclaimerKey) === "didAccept") {
        setShow(true);
      }
    };

    window.addEventListener("storage", handleStorage);

    // Also poll briefly in case disclaimer is accepted in the same tab
    const interval = setInterval(() => {
      if (localStorage.getItem(disclaimerKey) === "didAccept") {
        setShow(true);
        clearInterval(interval);
      }
    }, 500);

    return () => {
      window.removeEventListener("storage", handleStorage);
      clearInterval(interval);
    };
  }, [wasDismissed]);

  const handleDismiss = () => {
    localStorage.setItem(ANNOUNCEMENT_KEY, "true");
    setShow(false);
  };

  const footer = (
    <Button onClick={handleDismiss}>I understand</Button>
  );

  return (
    <React.Fragment>
      {show && <div className="fixed inset-0 z-50 backdrop-blur-xl"></div>}
      <ModalContainer
        title="Important Announcement"
        showModal={show}
        setShowModal={setShow}
        footer={footer}
      >
        <div className="space-y-6">
          <p className="text-base leading-relaxed dark:text-gray-100">
            We're happy to share that our{" "}
            <span className="font-bold text-green-400">
              migration is now complete
            </span>
            ! Thank you for your patience while we moved to our next generation
            platform.
          </p>
          <p className="text-base leading-relaxed dark:text-gray-100">
            Please take a moment to{" "}
            <span className="font-bold text-yellow-400">
              double-check your content and account
            </span>{" "}
            to make sure everything is in order.
          </p>
          <p className="text-base leading-relaxed dark:text-gray-100">
            If you run into any issues or notice anything missing, please reach
            out to us at{" "}
            <a
              href="mailto:support@pornpen.art"
              className="font-bold text-blue-400 underline"
            >
              support@pornpen.art
            </a>{" "}
            or{" "}
            <a
              href="mailto:abby@aimg.io"
              className="font-bold text-blue-400 underline"
            >
              abby@aimg.io
            </a>{" "}
            and we'll help you sort it out.
          </p>
          <p className="text-base leading-relaxed dark:text-gray-400">
            Thank you for being part of our community — we're excited for
            what's ahead!
          </p>
        </div>
      </ModalContainer>
    </React.Fragment>
  );
}
